import { render, staticRenderFns } from "./VideoTypeSubtitle.vue?vue&type=template&id=47f08412&"
import script from "./VideoTypeSubtitle.vue?vue&type=script&lang=js&"
export * from "./VideoTypeSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports